export default __webpack_public_path__ + "static/media/marker-label-event.de9156ac.svg";